import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalComponent } from './components/modal/modal';
import { ToastComponent } from './components/toast/toast';

@Component({
  imports: [RouterOutlet, ModalComponent, ToastComponent],
  selector: 'app-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('laurent-frontend');
}
